export const educationPlan: string[] = [
    "One-off full Market/Consumer Reports",
    "Universities & Educational institutions"
]